class ResponseError extends Error {
  statusCode: Response["status"];
  _response: Response;
  /**
   * Set the Error message to the text of the response body.
   * For html content type, parse the html and get the text in order to strip out html tags.
   * @param {Response} response Response object
   * @param {String} responseData string of the response body
   */
  constructor(response: Response, responseData: string) {
    super(responseData);
    this.name = "ResponseError";
    this.statusCode = response.status;
    this._response = response;
  }

  /**
   * Returns a next.js friendly error object.
   */
  toJSON() {
    return {
      message: this.message,
      stack: this.stack,
      statusCode: this.statusCode,
    };
  }
}

export default ResponseError;
